import React from 'react';
import { Checkbox, InputNumber, Select } from 'antd';
import styled from 'styled-components';

import { compoundStepCountOperators } from '../../constants/compound';

const { Option } = Select;

const StyledOptionsRow = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: ${({ showEnabled, showOptional, fromDashboard }) =>
    (showEnabled || showOptional) && !fromDashboard ? '20px' : '0px'};
`;

const StyledSelect = styled(Select)`
  max-width: 80px;
  flex-shrink: 0;
`;

const StyledCheckboxEnabled = styled(Checkbox)`
  white-space: nowrap;
`;

const StyledCheckboxOptional = styled(Checkbox)`
  white-space: nowrap;
  margin: 0;
`;

const CompoundOptionsContainer = ({
  showEnabled,
  showOptional,
  showCount,
  enabled,
  optional,
  count,
  countOperator,
  onEnabledStatusChange,
  onOptionalStatusChange,
  onCountChange,
  fromDashboard,
  isOnlyEnabledStep,
}) => (
  <div
    className="st-compound-step-options-container"
    style={
      fromDashboard
        ? { borderTop: '1px dashed rgb(217, 217, 217)' }
        : { borderLeft: '1px dashed rgb(217, 217, 217)' }
    }
  >
    <div className="st-compound-step-options" style={{ width: 'auto' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: fromDashboard ? 'row' : 'column',
          alignItems: fromDashboard ? 'center' : null,
        }}
      >
        <h4 style={{ marginBottom: 0, marginRight: '10px' }}>Options:</h4>
        {showCount && (
          <StyledOptionsRow
            showEnabled={showEnabled}
            showOptional={showOptional}
            fromDashboard={fromDashboard}
          >
            Count:&nbsp;
            <StyledSelect
              dropdownMatchSelectWidth
              dropdownStyle={{ width: 'auto' }}
              value={countOperator}
              onSelect={(c) => onCountChange(count, c)}
              className="ant-select-border-bottom"
              getPopupContainer={(triggerNode) => triggerNode}
              virtual={false}
            >
              {Object.values(compoundStepCountOperators).map((c) => (
                <Option key={c} value={c}>
                  {c}
                </Option>
              ))}
            </StyledSelect>
            &nbsp;
            <InputNumber
              defaultValue={count}
              min={1}
              max={999}
              value={count}
              className="ant-input-border-bottom"
              onChange={(v) => onCountChange(v, countOperator)}
            />
          </StyledOptionsRow>
        )}
        {showEnabled && (
          <StyledCheckboxEnabled
            onChange={(e) => onEnabledStatusChange(e.target.checked)}
            checked={enabled}
            disabled={isOnlyEnabledStep && enabled}
          >
            Enabled
          </StyledCheckboxEnabled>
        )}
        {showOptional && (
          <StyledCheckboxOptional
            onChange={(e) => onOptionalStatusChange(e.target.checked)}
            checked={optional}
          >
            Optional
          </StyledCheckboxOptional>
        )}
      </div>
    </div>
  </div>
);

export default CompoundOptionsContainer;
